import React from 'react'
import {Button, Modal} from 'react-bootstrap'

const FirstApprovalMessageConfirmationPopup = ({show, handleClose, message, setAllow}: any) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered'>
        <div className='modal-header text-center row'>
          <div className='icon-box col-12'>
            <i className={`fa fa-exclamation-circle fa-2x `}></i>
          </div>
          <h2>{message}</h2>
        </div>
        {/* <div className='modal-body'>{`Are you sure `}</div> */}
        <div className='modal-footer'>
          <Button color='secondary' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color='danger'
            onClick={() => {
              setAllow(true)
              handleClose()
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default FirstApprovalMessageConfirmationPopup
